import React, { useState } from 'react';
import { useLogin } from '../../../helpers/useApi';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const loginMutation = useLogin();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      loginMutation.reset(); // clear previous errors
      loginMutation.error = new Error(
        'Please enter both username and password',
      );
      return;
    }

    loginMutation.mutate(
      { username, password },
      {
        onSuccess: () => {
          window.location.href = '/admin/portal';
        },
      },
    );
  };

  return (
    <div className="App">
      <h1>Admin Login</h1>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          disabled={loginMutation.isPending}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          disabled={loginMutation.isPending}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" disabled={loginMutation.isPending}>
          {loginMutation.isPending ? 'Logging in...' : 'Log In'}
        </button>
      </form>

      {loginMutation.isError && (
        <p style={{ color: 'red' }}>
          {loginMutation.error instanceof Error
            ? loginMutation.error.message
            : String(loginMutation.error)}
        </p>
      )}

      {loginMutation.isSuccess && (
        <p style={{ color: 'green' }}>Login successful! Redirecting…</p>
      )}
    </div>
  );
}

export default AdminLogin;
